export var SkipDayLoadingText;
(function (SkipDayLoadingText) {
    SkipDayLoadingText["LOADING"] = "Loading Skip Days...";
})(SkipDayLoadingText || (SkipDayLoadingText = {}));
export var SkipDayUpdateToasts;
(function (SkipDayUpdateToasts) {
    SkipDayUpdateToasts["SKIP"] = "Successfully Skipped";
    SkipDayUpdateToasts["UNSKIP"] = "Successfully Un-Skipped";
    SkipDayUpdateToasts["ERROR_SKIP"] = "Failed to Skip";
    SkipDayUpdateToasts["ERROR_UNSKIP"] = "Failed to Un-Skip";
})(SkipDayUpdateToasts || (SkipDayUpdateToasts = {}));
